// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotAssignment\ApiPilotAssignment.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Pilot, PilotData, PilotOptions } from 'data/models/Pilot';
import { PilotJobOrder, PilotJobOrderData, PilotJobOrderOptions } from 'data/models/PilotJobOrder';

// PilotAssignmentData is the class that PilotAssignment serializes to/from
export interface PilotAssignmentData {
    PilotId : number;
    PilotJobOrderId : number;
    Url : string | null;
	
    Pilot : PilotData | null;
    PilotJobOrder : PilotJobOrderData | null;
	
    AssignmentOrder : number;
    PilotConfirmed : boolean;
}

// PilotAssignmentOptions is the class which may be passed to the PilotAssignment constructor to define optional initial data values
export interface PilotAssignmentOptions {
    PilotId : number;
    PilotJobOrderId : number;
    Url? : string | null;
	
    Pilot? : PilotOptions | null;
    PilotJobOrder? : PilotJobOrderOptions | null;
	
    AssignmentOrder? : number;
    PilotConfirmed? : boolean;
}

export class PilotAssignment {
    public PilotId : DataSignal<number>;
    public PilotJobOrderId : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public Pilot : DataSignal<Pilot | null>;
    public PilotJobOrder : DataSignal<PilotJobOrder | null>;
	
    public AssignmentOrder : DataSignal<number>;
    public PilotConfirmed : DataSignal<boolean>;

    constructor();
    constructor(data : PilotAssignmentOptions);
    constructor(data: PilotAssignmentOptions | null = null) {
        this.PilotId = jsonableObservable(S.value<number>(data && data.PilotId !== undefined ? data.PilotId : 0));
        this.PilotJobOrderId = jsonableObservable(S.value<number>(data && data.PilotJobOrderId !== undefined ? data.PilotJobOrderId : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.Pilot = S.value<Pilot | null>(null);
        this.PilotJobOrder = S.value<PilotJobOrder | null>(null);
	    
        this.AssignmentOrder = jsonableObservable(S.value<number>(data && data.AssignmentOrder !== undefined ? data.AssignmentOrder : 0));
        this.PilotConfirmed = jsonableObservable(S.value<boolean>(data && data.PilotConfirmed !== undefined ? data.PilotConfirmed : false));
    }

    static key(obj : PilotAssignment) {
        return obj.PilotId() + '\u2618' + obj.PilotJobOrderId();
    }
    
    static dataKey(obj : PilotAssignmentOptions) {
        return obj.PilotId + '\u2618' + obj.PilotJobOrderId;
    }

    static update(obj : PilotAssignment, data : PilotAssignmentOptions) {
        S.freeze(() => {
            if (data.PilotId !== undefined) obj.PilotId(data.PilotId);
            if (data.PilotJobOrderId !== undefined) obj.PilotJobOrderId(data.PilotJobOrderId);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
	        
            if (data.AssignmentOrder !== undefined) obj.AssignmentOrder(data.AssignmentOrder);
            if (data.PilotConfirmed !== undefined) obj.PilotConfirmed(data.PilotConfirmed);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PilotAssignment.ts